import React, { useState } from 'react';
import Modal from 'react-modal';
import RawSelector from './RawSelector';
import { reportIncorrectKyb } from '../services/vault/emailSupport';
import LoadingScreen from './LoadingScreen';
import { useForm, SubmitHandler } from 'react-hook-form';
import { STATES } from '../const';
import { SnapButton } from './SnapButton';

const SuccessSubmission = ({
  onCancelClose,
}: {
  onCancelClose: () => void;
}): React.JSX.Element => {
  return (
    <div>
      <div className='flex row justify-center'>
        <svg
          width={250}
          height={200}
          viewBox='0 0 250 200'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M219 127C219 125.616 219.411 124.262 220.18 123.111C220.949 121.96 222.042 121.063 223.321 120.533C224.6 120.003 226.008 119.864 227.366 120.135C228.723 120.405 229.971 121.071 230.95 122.05C231.929 123.029 232.595 124.277 232.865 125.634C233.136 126.992 232.997 128.4 232.467 129.679C231.937 130.958 231.04 132.051 229.889 132.82C228.738 133.589 227.384 134 226 134C224.143 134 222.363 133.262 221.05 131.95C219.737 130.637 219 128.857 219 127ZM63 134C61.1435 134 59.363 133.262 58.0503 131.95C56.7375 130.637 56 128.857 56 127C56 125.143 56.7375 123.363 58.0503 122.05C59.363 120.737 61.1435 120 63 120H24C22.1435 120 20.363 119.263 19.0503 117.95C17.7375 116.637 17 114.857 17 113C17 111.143 17.7375 109.363 19.0503 108.05C20.363 106.737 22.1435 106 24 106H64C65.8565 106 67.637 105.263 68.9497 103.95C70.2625 102.637 71 100.857 71 99C71 97.1435 70.2625 95.363 68.9497 94.0503C67.637 92.7375 65.8565 92 64 92H39C37.1435 92 35.363 91.2625 34.0503 89.9497C32.7375 88.637 32 86.8565 32 85C32 83.1435 32.7375 81.363 34.0503 80.0503C35.363 78.7375 37.1435 78 39 78H79C77.1435 78 75.363 77.2625 74.0503 75.9497C72.7375 74.637 72 72.8565 72 71C72 69.1435 72.7375 67.363 74.0503 66.0503C75.363 64.7375 77.1435 64 79 64H136C137.857 64 139.637 64.7375 140.95 66.0503C142.262 67.363 143 69.1435 143 71C143 72.8565 142.262 74.637 140.95 75.9497C139.637 77.2625 137.857 78 136 78H200C201.857 78 203.637 78.7375 204.95 80.0503C206.263 81.363 207 83.1435 207 85C207 86.8565 206.263 88.637 204.95 89.9497C203.637 91.2625 201.857 92 200 92H222C223.857 92 225.637 92.7375 226.95 94.0503C228.263 95.363 229 97.1435 229 99C229 100.857 228.263 102.637 226.95 103.95C225.637 105.263 223.857 106 222 106H203C201.143 106 199.363 106.737 198.05 108.05C196.737 109.363 196 111.143 196 113C196 114.857 196.737 116.637 198.05 117.95C199.363 119.263 201.143 120 203 120H209C210.857 120 212.637 120.737 213.95 122.05C215.263 123.363 216 125.143 216 127C216 128.857 215.263 130.637 213.95 131.95C212.637 133.262 210.857 134 209 134H63Z'
            fill='#DBEAFE'
          />
          <path
            d='M167.22 132.432C167.22 132.432 163.255 136.729 160.5 139C157.745 141.271 153.271 144.109 153.271 144.109C147.505 147.308 141.136 149.272 134.57 149.877C126.79 150.602 118.949 149.436 111.717 146.477C105.555 143.948 99.9862 140.162 95.3667 135.363C92.4235 132.321 89.8911 128.907 87.8341 125.207C82.6666 115.893 80.7443 105.125 82.3701 94.5978C83.9959 84.071 89.0774 74.3841 96.8141 67.0628C104.551 59.7416 114.503 55.2021 125.104 54.1593C135.704 53.1165 146.35 55.6297 155.366 61.303C160.924 64.8131 165.717 69.4106 169.454 74.8192C175.381 83.3653 178.368 93.6068 177.965 103.999C177.562 114.391 173.791 124.371 167.22 132.432Z'
            fill='white'
            stroke='#3B82F6'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
          />
          <path
            d='M176.5 45V51'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M176.5 59V65'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M166.5 55H172.5'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M180.5 55H186.5'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M93.5 148V152'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M93.5 160V164'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M85.5 156H89.5'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M97.5 156H101.5'
            stroke='#60A5FA'
            strokeWidth='2.5'
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M96.8792 74.1746C96.4347 74.7028 96.5026 75.4914 97.0308 75.9359C97.559 76.3804 98.3475 76.3125 98.792 75.7843L96.8792 74.1746ZM100.821 71.7805L101.69 72.6792L101.691 72.6782L100.821 71.7805ZM115.166 62.691L116.358 62.3156C116.255 61.9881 116.021 61.7173 115.713 61.5671C115.404 61.4168 115.047 61.4002 114.725 61.5212L115.166 62.691ZM113.974 63.0685C114.181 63.727 114.883 64.0928 115.542 63.8855C116.2 63.6781 116.566 62.9763 116.359 62.3178L113.974 63.0685ZM90.5175 84.3486C90.236 84.9789 90.5188 85.7181 91.1492 85.9996C91.7796 86.2811 92.5188 85.9982 92.8002 85.3679L90.5175 84.3486ZM92.9279 82.2546L94.0315 82.8417L94.0332 82.8383L92.9279 82.2546ZM96.0063 79.513C96.3869 78.9371 96.2286 78.1616 95.6526 77.781C95.0767 77.4004 94.3012 77.5588 93.9206 78.1347L96.0063 79.513ZM98.792 75.7843C99.7042 74.7003 100.672 73.6639 101.69 72.6792L99.9525 70.8818C98.8723 71.9261 97.8466 73.0251 96.8792 74.1746L98.792 75.7843ZM101.691 72.6782C105.676 68.8168 110.413 65.8156 115.606 63.8609L114.725 61.5212C109.211 63.5965 104.183 66.783 99.9514 70.8828L101.691 72.6782ZM113.973 63.0664L113.974 63.0685L116.359 62.3178L116.358 62.3156L113.973 63.0664ZM92.8002 85.3679C93.1848 84.5065 93.5966 83.6591 94.0315 82.8417L91.8243 81.6676C91.3607 82.5392 90.9239 83.4384 90.5175 84.3486L92.8002 85.3679ZM94.0332 82.8383C94.6302 81.708 95.2979 80.5851 96.0063 79.513L93.9206 78.1347C93.1687 79.2726 92.459 80.4658 91.8226 81.6709L94.0332 82.8383Z'
            fill='#60A5FA'
          />
          <path
            d='M110.98 101.369C110.277 100.738 109.355 100.409 108.411 100.451C107.468 100.493 106.578 100.903 105.934 101.594C105.618 101.934 105.373 102.333 105.213 102.768C105.054 103.203 104.982 103.666 105.004 104.129C105.025 104.593 105.138 105.047 105.337 105.466C105.536 105.885 105.816 106.26 106.162 106.569L122.971 121.71C123.955 122.593 125.247 123.054 126.567 122.995C127.888 122.936 129.133 122.362 130.035 121.395C130.113 121.31 130.113 121.31 130.188 121.222L154.175 92.773C154.475 92.4189 154.701 92.0086 154.84 91.566C154.979 91.1235 155.028 90.6577 154.985 90.1958C154.942 89.7339 154.807 89.2853 154.589 88.8761C154.37 88.467 154.072 88.1056 153.712 87.813C152.981 87.2155 152.045 86.9286 151.104 87.0138C150.164 87.0991 149.295 87.5498 148.683 88.269L126.131 115.016L110.98 101.369Z'
            fill='#BFDBFE'
            stroke='#3B82F6'
            strokeWidth='2.5'
            strokeMiterlimit={10}
          />
        </svg>
      </div>
      <div className='form-state-page-title'>Thank you</div>
      <div className='form-state-page-subtitle my-1'>
        Your organization information has successfully been submitted for review
        to the support team. Please note, we may reach out for additional
        information.
      </div>
      <div className='flex row my-4 justify-end'>
        <SnapButton onClick={onCancelClose} variant='primary'>
          Close
        </SnapButton>
      </div>
    </div>
  );
};

type FormValues = {
  orgLegalName: string;
  orgEin: string;
  orgAddressStreet: string;
  orgAddressState: string;
  orgAddressCity: string;
  orgAddressZip: string;
  comment?: string;
};

export default function EditModal({
  onCancelClose,
  isOpen,
  raiseConfig,
}: {
  isOpen: boolean;
  onCancelClose: () => void;
  raiseConfig?: {
    raiseCampaignId?: string;
    raiseUserId?: string;
  };
}): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);
  const [orgAddressState, setOrgAddressState] = useState(STATES[0].value);
  const [isSubmitted, setIsSubmitted] = useState<null | boolean>(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormValues>();

  const handleStateChange = (value?: string): void => {
    if (value === undefined) {
      return;
    }
    setOrgAddressState(value);
  };

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    try {
      setIsLoading(true);
      const response = await reportIncorrectKyb({
        ...data,
        orgAddressState: orgAddressState || 'AL',
        ...raiseConfig,
      });
      setIsLoading(false);
      reset();
      setIsSubmitted(response ? true : false);
    } catch (e) {
      setIsLoading(false);
      setIsSubmitted(false);
    }
  };

  const formattedStates = STATES.map((s) => ({
    ...s,
    selected: s.value === orgAddressState,
  }));
  return (
    <Modal
      isOpen={isOpen}
      overlayClassName={
        'flex inset-0 fixed z-50 backdrop-blur-sm overflow-y-auto bg-black/30'
      }
      className={`tablet:rounded-lg m-auto bg-white p-4 shadow-md tablet:max-w-[705px]`}
    >
      {isLoading ? (
        <div className='flex justify-center items-center'>
          <LoadingScreen />
        </div>
      ) : (
        <div>
          {isSubmitted === true ? (
            <SuccessSubmission onCancelClose={onCancelClose} />
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div>
                <p style={{ fontSize: '25px' }} className='font-bold mb-3'>
                  Report Incorrect Organization Information
                </p>

                <p
                  className='mb-3'
                  style={{
                    fontSize: 13,
                  }}
                >
                  Please enter the information of the organization that will
                  handle any funds raised from this campaign.
                </p>
                <div className='page-text-alert'>
                  <p>
                    Reporting incorrect organization information will lock the
                    form until the information is changed by our support team.
                  </p>
                </div>
                <div className='md:flex tablet:flex my-2 gap-2'>
                  <div className='md:w-1/2 tablet:w-1/2 md:mb-0 tablet:mb-0'>
                    <label className='text-sm font-medium text-[#1e293b] leading-5'>
                      Payable Name <span className='text-black'>*</span>
                    </label>
                    <input
                      className='appearance-none block bg-grey-lighter text-grey-darker border border-red rounded py-2 px-4 mb-1'
                      type='text'
                      id='orgLegalName'
                      {...register('orgLegalName', {
                        required: true,
                      })}
                    />
                    {errors.orgLegalName?.type === 'required' && (
                      <span className='text-sm text-red-500'>
                        Field is required.
                      </span>
                    )}
                  </div>
                  <div className='md:w-1/2 tablet:w-1/2'>
                    <label
                      className='text-sm font-medium text-[#1e293b] leading-5'
                      htmlFor='org-ein'
                    >
                      Tax ID / EIN <span className='text-black'>*</span>
                    </label>
                    <input
                      className='appearance-none block bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-2 px-4'
                      type='text'
                      id='orgEin'
                      {...register('orgEin', {
                        required: true,
                      })}
                    />
                    {errors.orgEin?.type === 'required' && (
                      <span className='text-sm text-red-500'>
                        Field is required.
                      </span>
                    )}
                  </div>
                </div>
                <div className='md:flex tablet:flex '>
                  <div className='w-full'>
                    <label
                      className='text-sm font-medium text-[#1e293b] leading-5'
                      htmlFor='org-address-street'
                    >
                      Organization&apos;s Street Address
                      <span className='text-black'>*</span>
                    </label>
                    <input
                      className='appearance-none block bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-2 px-4 mb-1'
                      type='text'
                      id='orgAddressStreet'
                      {...register('orgAddressStreet', {
                        required: true,
                      })}
                    />
                    {errors?.orgAddressStreet?.type === 'required' && (
                      <span className='text-sm text-red-500'>
                        Field is required.
                      </span>
                    )}
                  </div>
                </div>
                <div className='md:flex tablet:flex gap-2'>
                  <div className='md:w-1/2 tablet:w-1/2 md:mb-0 tablet:mb-0'>
                    <label
                      className='text-sm font-medium text-[#1e293b] leading-5'
                      htmlFor='org-city'
                    >
                      City
                      <span className='text-black'>*</span>
                    </label>
                    <input
                      className='appearance-none block bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-2 px-4'
                      type='text'
                      id='orgAddressZip'
                      {...register('orgAddressCity', {
                        required: true,
                      })}
                    />
                    {errors.orgAddressCity?.type === 'required' && (
                      <span className='text-sm text-red-500'>
                        Field is required.
                      </span>
                    )}
                  </div>
                  <div className='md:w-1/2 tablet:w-1/2 mb-2'>
                    <RawSelector
                      label='State'
                      options={formattedStates}
                      onChange={handleStateChange}
                    />
                  </div>
                  <div className='md:w-1/2 tablet:w-1/2'>
                    <label
                      className='text-sm font-medium text-[#1e293b] leading-5'
                      htmlFor='org-zip'
                    >
                      Zip
                      <span className='text-black'>*</span>
                    </label>
                    <input
                      className='appearance-none block bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-2 px-4'
                      type='text'
                      id='orgAddressZip'
                      {...register('orgAddressZip', {
                        required: true,
                      })}
                    />
                    {errors.orgAddressZip?.type === 'required' && (
                      <span className='text-sm text-red-500'>
                        Field is required.
                      </span>
                    )}
                  </div>
                </div>
                <div className='md:flex tablet:flex  mb-4'>
                  <div className='md:w-full tablet:w-full'>
                    <label
                      className='text-sm font-medium text-[#1e293b] leading-5'
                      htmlFor='org-comments'
                    >
                      Comments
                    </label>
                    <textarea
                      style={{
                        resize: 'none',
                      }}
                      id='comment'
                      {...register('comment')}
                      rows={3}
                      className='block p-2.5 text-sm text-gray-900 rounded-lg border border-gray-300'
                    />
                  </div>
                </div>
              </div>
              {isSubmitted === false ? (
                <div
                  className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative'
                  role='alert'
                >
                  <span className='block sm:inline'>
                    Your report of incorrect organization details has failed to
                    send. Please try again.
                  </span>
                </div>
              ) : null}
              <div className='flex row my-2'>
                <button
                  type={'submit'}
                  hidden={true}
                  aria-hidden={true}
                  className={'fake-submit-button hidden'}
                />
                <SnapButton variant='primary' type={'submit'}>
                  Send
                </SnapButton>

                <SnapButton
                  onClick={onCancelClose}
                  variant='tertiary'
                  className='mx-2'
                >
                  Cancel
                </SnapButton>
              </div>
            </form>
          )}
        </div>
      )}
    </Modal>
  );
}
